<template>
  <pop-up
    title="Provider Form"
    button-text="Submit"
    :disabled="loadingProvider || updatingProvider || addingProvider"
    :spinning="loadingProvider || updatingProvider || addingProvider"
    class="top-fade-in"
    @add="validateForm"
    @close="$emit('close')"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <div class="provider-table-wrapper">
        <loading-page
          v-if="loadingProvider || updatingProvider || addingProvider"
          class="loading m-0 p-0"
        />
        <div v-else>
          <validation-observer ref="providerForm">
            <div class="container">
              <div class="m-auto">
                <div class="col-12 d-flex flex-wrap">
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    class="col-12 col-md-6 p-0 pr-md-1"
                    rules="required|min:3|max:50"
                  >
                    <input-field
                      label="Name*"
                      label-position="top"
                      :error="errors.length ? errors[0] : null"
                    >
                      <b-form-input
                        v-model.trim="provider.name"
                        :state="errors.length > 0 ? false : null"
                      />
                    </input-field>
                  </validation-provider>
                  <validation-provider
                    #default="{ errors }"
                    name="Type"
                    class="col-12 col-md-6 p-0 pl-md-1"
                    rules="required"
                  >
                    <input-field
                      label="Type*"
                      label-position="top"
                      :error="errors.length ? errors[0] : null"
                    >
                      <v-select
                        v-model="providerType"
                        class="w-100 type-select"
                        label="value"
                        :options="provider.typeOptions"
                      />
                    </input-field>
                  </validation-provider>
                </div>
                <div class="col-12">
                  <validation-provider
                    #default="{ errors }"
                    name="Webhook Url"
                    rules="required"
                  >
                    <input-field
                      label="Webhook Url*"
                      label-position="top"
                      :error="errors.length ? errors[0] : null"
                    >
                      <b-form-input
                        v-model.trim="provider.webhookUrl"
                        :state="errors.length > 0 ? false : null"
                      />
                    </input-field>
                  </validation-provider>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
    </transition>
  </pop-up>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { required } from '@validations'
import redirectError from '@/services/redirectError'
import PopUp from '@/components/popup/Pop-up.vue'

export default {
  name: 'ProviderForm',
  components: {
    PopUp,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    details: {
      type: Boolean,
      default: false,
    },
    providerId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      required,
      providerType: null,
    }
  },
  computed: {
    loadingProvider() {
      return this.$store.state.providers.gettingProvider
    },
    updatingProvider() {
      return this.$store.state.providers.updatingProvider
    },
    addingProvider() {
      return this.$store.state.providers.addingProvider
    },
    provider() {
      return this.$store.state.providers.provider
    },
  },
  created() {
    this.getProvider()
  },
  methods: {
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.providerForm.validate().then(success => {
          if (success) {
            this.submit()
            resolve(true)
          } else {
            this.errorToast('Check if all fields are valid!')
            reject()
          }
        })
      })
    },
    onSearch(query) {
      this.search = query
      this.offset = 0
    },
    getProvider() {
      this.$store
        .dispatch('providers/getProvider', this.details ? this.providerId : 0)
        .then(() => {
          this.providerType = this.provider.typeOptions.find(
            e => e.id === this.provider.type,
          )
          if (this.provider.providers && this.provider.providers.length > 0) {
            this.provider.providers.forEach(provider => {
              this.selected.push(provider)
            })
          }
        })
        .catch(err => {
          redirectError(err)
        })
    },
    submit() {
      this.provider.type = this.providerType.id
      this.$emit('submit', this.provider)
    },
  },
}
</script>

<style lang="scss" scoped>
.provider-table-wrapper {
  .pagination {
    display: flex;
    margin: 0.25rem 0.25rem 0;

    .pagination-buttons {
      flex-grow: 1;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .type-select {
    ::v-deep {
      .vs__dropdown-toggle {
        min-height: 42px;
        max-height: 42px;
        padding-bottom: 0;
        .vs__selected {
          overflow: hidden;
          margin-top: 0;
          height: 100%;
        }
      }
    }
  }
  .loading::v-deep {
    padding: 2.4rem !important;
  }
  .details {
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.2s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
